import { render, staticRenderFns } from "./SnackbarCerrarTab.vue?vue&type=template&id=0abdb60f"
import script from "./SnackbarCerrarTab.vue?vue&type=script&lang=ts"
export * from "./SnackbarCerrarTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports